import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector:     'history-box',
  templateUrl:  'history-box.component.html',
  host: { '[class.display-none]': '!loading && (!entries || !entries.length)'},
  styleUrls: ['./history-box.component.sass'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class HistoryBoxComponent {
  @Input() title:      string;
  @Input() entries:    any[];
  @Input() readOnly:   boolean = true;
  @Input() simplified: boolean;
  @Input() photoTn:    boolean;
  @Input() loading:    boolean;

  boxOpen: boolean = false;
  constructor() { }

  toggleBox(e): void {
    e.stopPropagation();
    this.boxOpen = !this.boxOpen;
  }
}
